export default __webpack_public_path__ + "static/media/6.b7d2870d.jpg";